<template>
    <div>
        <div class="simple-row">
            <div class="left">
                <el-button class="el-search-btn" type="primary" @click="addAddrDlg();">新增</el-button>
            </div>
        </div>
        <div v-if="checkBox" class="table-layout">
            <el-table ref="addrList" :data="addrList" border style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column align="center" type="selection" :selectable="selectable" width="55"></el-table-column>
                <el-table-column align="left" width="150" prop="alias" label="地址别名" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" width="200" prop="regionName" label="地址信息" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.regionName || ''}}{{scope.row.street || ''}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="是否默认" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="addrFlag == true">
                            <el-tag v-if="scope.row.defRevcFlag == true" type="danger">默认</el-tag>
                        </span>
                        <span v-else>
                            <el-tag v-if="scope.row.defSendFlag == true" type="danger">默认</el-tag>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="table-layout" v-else>
            <el-table :data="addrList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                <el-table-column width="55">
                    <template slot-scope="rows">
                        <div class="copy-radio" :class="{'circle' : checlAddrInfo!= null && checlAddrInfo.id == rows.row.id}">
                            <div class="circle-dot"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="left" width="150" prop="alias" label="地址别名" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" width="200" prop="regionName" label="地址信息" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.regionName || ''}}{{scope.row.street || ''}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="是否默认" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="addrFlag == true">
                            <el-tag v-if="scope.row.defRevcFlag == true" type="danger">默认</el-tag>
                        </span>
                        <span v-else>
                            <el-tag v-if="scope.row.defSendFlag == true" type="danger">默认</el-tag>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import retailerApi from '../../api/retailer'

    import SwbSaveRetailerAddr from './SaveRetailerAddr';
    Vue.regist(SwbSaveRetailerAddr);

    export default {
        name: 'swb-retailer-addr-select',
        desc: '零售商业务地址列表',
        props: {
            checkBox: {
                type: Boolean,
                default: true
            },
            addrFlag: {
                type: Boolean,
                default: true
            },
            comId: {
                type: Number,
                default: function () {
                    return {};
                }
            },
            addrIds: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data: function () {
            return {
                addrList: [],
                selectAddrList: [],
                checlAddrInfo: null
            }
        },
        created: function () {
            this.getRetailerAddrListByComId();
        },
        methods: {
            getRetailerAddrListByComId: function () {
                let self = this;
                let postData = {};
                postData.comId = self.comId || null;
                let addrFlag = self.addrFlag;
                if(addrFlag == true) {
                    postData.recvFlag = true;
                } else {
                    postData.sendFlag = true;
                }
                retailerApi.getRetailerAddrList(postData, function (result) {
                    if(result.type == "info") {
                        let addrList = result.data
                        //
                        self.addrList = addrList;
                        //
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            addAddrDlg: function (item) {
                let selfDlg = this;
                Vue.$showDialog({
                    title: '公司业务地址',
                    template: '<div>' +
                    '<swb-save-retailer-addr :item="_item" ref="swb_retailerAddr_info"></swb-save-retailer-addr>' +
                    '</div>',
                    data: {
                        _item: null,
                    },
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.swb_retailerAddr_info.getDlgResult() || {};
                        // 成功执行
                        if(result.type == 'info') {
                            // 处理你的信息添加赋值
                            let postData = result.data;
                            postData.comId = selfDlg.comId;
                            postData.recvFlag = true;
                            selfDlg.saveRetailerAddr(postData);
                            return true;
                        } else {
                            this.$message.error("返回出错");
                        }
                        return false;
                    },
                    lifecycle: {
                        created: function () {
                            this._item = {};
                            if(item && item.id) {
                                this._item.id = item.id;
                            }
                        }
                    }
                })

            },
            saveRetailerAddr: function (postData) {
                let self = this;
                retailerApi.saveRetailerAddr(postData, function (result) {
                    if(result.type == 'info') {
                        self.getRetailerAddrListByComId();
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            selectable: function (row, index) {
                let addrIds = this.addrIds;
                if(addrIds.indexOf(row.id) >= 0) {
                    return false;
                } else {
                    return true;
                }
            },
            handleSelectionChange: function (val) {
                this.selectAddrList = val;
            },
            handleCurrentChange: function (val) {
                this.checlAddrInfo = Utils.merge({}, val);
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let checkBox = self.checkBox;
                if(checkBox) {
                    let addrList = self.selectAddrList;
                    if(addrList != null && addrList.length > 0) {
                        result.type = "info";
                        result.data = self.selectAddrList();
                    } else {
                        result.type = 'warn';
                        result.message = '至少选择一个地址！';
                    }
                } else {
                    let checlAddrInfo = self.checlAddrInfo;
                    if(checlAddrInfo != null) {
                        result.type = "info";
                        result.data = checlAddrInfo;
                    } else {
                        result.type = 'warn';
                        result.message = '请选择一个地址！';
                    }
                }
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/retailer/RetailerAddrSelect.vue